/**
 * Created by hj on 2017/8/17.
 */
import React from 'react';
import { DmsTab, TableView } from '../../components';
import { Button, Table, Modal } from 'antd';
import { hashHistory } from 'react-router';
import { openNotice } from 'Utils';
import moment from 'moment';
import { getPromotionDetail, getPromotionIsEdit, getPromotionLineList } from '../../service/promotion';

class promotionDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['促销详情'],
			detailData: {},
			visibleOrder: false,
			selectPromotion: {},
			searchObj: {
				p: 1,
				s: 10,
				promotionProductId: ''
			},
			rows: [],
			total: 0
		}
	}

	pageChange(page, pageSize) {
		/* 翻页 刷新 */
		let self = this;
		this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
			self.refreshPromotionLine();
		});
	}

	initData (key) {
		let promotionId = this.props.routeParams.promotionId;
		let self = this;
		getPromotionDetail(promotionId).then((result) => {
			if (result && result.code == '200') {
				let detail = result.data || {};
				getPromotionIsEdit(promotionId).then((editResult) => {
					if (editResult && editResult.code == 200) {
						detail.modifiable = editResult.data || false;
					}
					self.setState({
						'detailData': detail
					});
				});
			} else {
				openNotice('error', '促销详情获取失败', (result && result.message) ? result.message : '');
				self.backTo();
			}
		});
	}

	componentDidMount () {
		this.initData(1);
	}

	backTo() {
		window.history.go(-1);
	}

	toEdit () {
		// 编辑,判断促销是否可编辑
		let self = this;
		let id = this.state.detailData.id;
		getPromotionIsEdit(id).then((result) => {
			if (!result || result.code != 200) {
				openNotice('error', '数据获取失败，请重试', '');
				return;
			}
			
			if (result.data == true) {
				// 用权限编辑
				hashHistory.push('/promotion/add/' + id);
			} else {
				openNotice('warning', '该促销不能编辑', '');
				self.setState({
					'detailData': {
						...self.state.detailData,
						'modifiable': false
					}
				});
			}
		});
	}

	refreshPromotionLine () {
		let self = this;
		let searchObj = self.state.searchObj;
		getPromotionLineList(searchObj).then((result) => {
			if (!result || result.code != 200) {
				openNotice('error', '促销行的已购订单获取失败，请重试', '');
				return;
			}
			self.setState({
				'rows': result.data || [],
				'total': result.total
			});
		});
	}
	openOrderModelFn (item) {
		let self = this;
		// 查询促销行的已购订单列表
		let searchObj = self.state.searchObj;
		searchObj.promotionProductId = item.id;
		self.setState({
			'visibleOrder': true,
			'selectPromotion': item,
			'searchObj': searchObj
		});
		self.refreshPromotionLine();
	}
	handleOrderCancel () {
		this.setState({
			visibleOrder: false
		});
	}

	render() {
		const { opts, detailData, visibleOrder, selectPromotion, total, rows, searchObj } = this.state;
		const promotionProps = {
			rowKey: 'id',
			columns: [
				{
					title: '产品名称',
					dataIndex: 'productName'
				}, {
					title: '产品分类',
					dataIndex: 'productCategoryName'
				}, {
					title: '规格',
					dataIndex: 'productSpecName'
				}, {
					title: '单位',
					dataIndex: 'unitText'
				}, {
					title: '产品标价(元)',
					dataIndex: 'showPrice'
				}, {
					title: '折扣(%)',
					dataIndex: 'discount'
				}, {
					title: '折扣后价格(元)',
					dataIndex: 'discountedPrice'
				}, {
					title: '总量限制',
					dataIndex: 'quantityLimit'
				}, {
					title: '每人限制',
					dataIndex: 'personalLimit'
				}, {
					title: '已购买数量',
					dataIndex: 'soldQuantity',
					render: (text, record, index) => {
						return <a onClick={this.openOrderModelFn.bind(this, record)} style={{display: 'block', width: '100%', height: '100%'}}>{text || 0}</a>
					}
				}
			],
			dataSource: detailData.productList || []
		};
		let self = this;
		let editBtnRender = function () {
			if (detailData.modifiable == true) {
				return <Button onClick={self.toEdit.bind(self)}>编辑</Button>
			} else {
				return '';
			}
		};
		let renderPromotionFn = function () {
			if (selectPromotion.productId) {
				return <div className="show_promotion">
					<p>商品：{selectPromotion.productName}</p>
					<p>规格：{selectPromotion.productSpecName || '无'}</p>
				</div>
			} else {
				return <div className="show_promotion">
					<p>分类：{selectPromotion.productCategoryName}</p>
				</div>
			}
		};
		const orderProps = {
			loading: false,//更新表格数据中
				rowKey: 'id',
				pageParam: {
				total: total,
					current: searchObj.p,//当前页码
					pageSize: searchObj.s,//当前分页数
					onChange: self.pageChange.bind(self)
			},
			columns: [
				{
					title: '客户',
					dataIndex: 'customerName'
				}, {
					title: '下单时间',
					dataIndex: 'orderTime'
				}, {
					title: '下单数量',
					dataIndex: 'count'
				}, {
					title: '订单编号',
					dataIndex: 'orderCode'
				}
			],
			rows
		};
		return <div className="dms-body">
			<DmsTab options={opts} defaultKey={0}>
				{editBtnRender()}
				<Button onClick={this.backTo.bind(this)}>返回</Button>
			</DmsTab>
			<div className="dms-table-box" style={{padding: 0, position: 'relative'}}>
				<div className="order_detail">
					<div className="infor">
						<a style={{'width': '33%'}}>
							<p><label>编号</label><span>{detailData.code}</span></p>
							<p><label>创建人</label><span>{detailData.creator}</span></p>
							<p><label>活动开始</label><span>{detailData.startTime}</span></p>
							<span className="l"></span>
						</a>
						<a style={{'width': '33%'}}>
							<p><label>活动分类</label><span>{detailData.categoryText}</span></p>
							<p><label>创建时间</label><span>{moment(detailData.createdDate).format('YYYY-MM-DD HH:mm:ss')}</span></p>
							<p><label>活动结束</label><span>{detailData.endTime}</span></p>
							<span className="l"></span>
						</a>
						<a style={{'width': '33%'}}>
							<p><label>状态</label><span>{detailData.activeText}</span></p>
							<p><label>最后更新</label><span>{moment(detailData.lastUpdateTime).format('YYYY-MM-DD HH:mm:ss')}</span></p>
							<p style={{color: '#fafafa'}}>-</p>
						</a>
					</div>
				</div>
				<DmsTab className="white-bg no-border" options={['适用范围']} defaultKey={0}></DmsTab>
				<div className="detail_text">{detailData.scope || '全部'}</div>
				<DmsTab className="white-bg no-border" options={['适用产品']} defaultKey={0}></DmsTab>
				<div className="dms-table-box">
					<Table {...promotionProps} bordered pagination={false}/>
				</div>
				<DmsTab className="white-bg no-border" options={['更多']} defaultKey={0}></DmsTab>
				<div className="detail_text">备注：{detailData.description || '-'}</div>
			</div>
			<Modal
				visible={visibleOrder}
				title="活动效果"
				onCancel={self.handleOrderCancel.bind(self)}
				width={'80%'}
				footer={[
            <Button key="back" size="large" onClick={self.handleOrderCancel.bind(self)}>取消</Button>
          ]}
			>
				{renderPromotionFn()}
				<TableView {...orderProps}/>
			</Modal>
		</div>
	}
};
export default promotionDetail;


// WEBPACK FOOTER //
// ./src/routes/promotion/detail.js